import React, { useEffect, useState } from "react";
import { Button, Typography } from "@material-ui/core";
import { Link } from "gatsby";
import { AnchorLink } from "gatsby-plugin-anchor-links";
import { getStyles } from "../util/getStyles";

const ButtonComp = (props) => {
  const [styles, setStyles] = useState({});
  const [isAnchor, setIsAnchor] = useState(false);

  useEffect(() => {
    let newStyles = {};
    const settings = [props];

    if (settings[0].link) {
      if (settings[0].link.url.includes("#")) {
        setIsAnchor(true);
      }
    }

    newStyles = { ...getStyles(props), textDecoration: "none" };

    setStyles(newStyles);
  }, [props]);

  if (isAnchor) {
    return (
      <AnchorLink to={`${props.link.url}`} style={{ textDecoration: "none" }}>
        <Button style={styles}>{props.text}</Button>
      </AnchorLink>
    );
  } else {
    return (
      <Link
        color="inherit"
        to={`${props.link.url}`}
        style={{ textDecoration: "none" }}
      >
        <Button style={styles}>{props.text}</Button>
      </Link>
    );
  }
};
export default ButtonComp;
